export default __webpack_public_path__ + "static/media/feedback_correct_01.051b6a38.png";